import React from "react";

export default () => (
  <svg
    className="fill-current inline"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M6,18 L20,18 L20,16 L6,16 L6,18 Z M2.66453526e-15,4 L14,4 L14,2 L2.66453526e-15,2 L2.66453526e-15,4 Z M2.66453526e-15,11 L20,11 L20,9 L2.66453526e-15,9 L2.66453526e-15,11 Z"
      id="path-menu"
    />
  </svg>
);
